import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { ILocationState }  from 'Redux/Slices/Location/LocationSlice';
import { Location }        from 'Domain/Models';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const createLocationRequest = (state: Draft<ILocationState>, { type }: PayloadAction<{ formData: any }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.lastUpdateId = null;
  state.updatedAt = Date.now();
};

export const createLocationSuccess = (state: Draft<ILocationState>, { type, payload }: PayloadAction<{
  location: Location
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.lastUpdateId = payload.location.id;
  state.entries = { ...state.entries, [payload.location.id]: payload.location };
};

export const createLocationFailure = (state: Draft<ILocationState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
